import { Component, OnInit } from '@angular/core';
import *as moment from "moment";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { EnquiryService } from 'src/app/services/Enquiry/enquiry.service';

@Component({
  selector: 'app-reception',
  templateUrl: './reception.component.html',
  styleUrls: ['./reception.component.css']
})
export class ReceptionComponent implements OnInit {

  constructor(private enquiryService: EnquiryService, private lookupService: LookupService, public globalHelper: GlobalHelper,private spinnerService: Ng4LoadingSpinnerService) { }
  EnquiryModel = {
    VisitorID: 0,
    EnquiryTypeID: 0,
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Mobile: '',
    Address: '',
    Email: '',
    Description: '',
    PhotoPath: null,
    IsMeeting: false,
    MeetingDate: moment(new Date()).format('DD-MMM-YYYY'),
    MeetingTime: moment(new Date()).format('HH:mm'),
    INTime:moment(new Date()).format('HH:mm'),
    Agenda: '',
    StaffID: 0,
    IsProspectus: false,
    Amount: 0,
    PaymentMode: 'CASH',
    ChequeDate: '',
    ChequeNo: '',
    BankID: 0,
    Remarks: '',
    EnquiryNo: '',
    IsActive: false,
    EnquirySourceID: 0,
}
SelectedVisitor ($item) {
    this.EnquiryModel.VisitorID = $item.VisitorID;
    this.EnquiryModel.FirstName = $item.FirstName;
    this.EnquiryModel.MiddleName = $item.MiddleName;
    this.EnquiryModel.LastName = $item.LastName;
    this.EnquiryModel.Mobile = $item.Mobile;
    this.EnquiryModel.Address = $item.Address;
    this.EnquiryModel.Email = $item.Email;
    this.EnquiryModel.PhotoPath = $item.PhotoPath;
}
VisitorList:any;
GetVisitor () {
    var itemBo = {
        'ItemCode1': this.EnquiryModel.Mobile,
    };
    this.lookupService.GetLookupsList('SearchVisitor', JSON.stringify(itemBo)).subscribe((data: any) => {
        this.VisitorList = data.LookupItems;
    });
};
SearchModel = {
    EnquirySourceID:0,
    EnquiryNo: '',
    EnquiryTypeID: 0,
    Mobile: '',
    FromDate: '',
    ToDate: '',
    CurrentIndex: 0,
    Address:'',
    PageSize: 20,
    PersonTypeID: 0,
    FirstName:''
  
}
EnquiryList:any;
ClearSearch () {
    this.EnquiryList = [];
    this.SearchModel.EnquiryNo = '';
    this.SearchModel.EnquiryTypeID = 0;
    this.SearchModel.EnquirySourceID = 0;
    this.SearchModel.PersonTypeID = 0;
    this.SearchModel.Mobile = '';
    this.SearchModel.FromDate = '';
    this.SearchModel.ToDate = '';
    this.SearchModel.Address = '';
    this.SearchModel.FirstName = '';
}
currentPage = 1;
pageSize = 20;
recordCount = 0;
totalPages = 0;
numberOfPages  () {

  this.totalPages = Math.ceil(this.recordCount / this.pageSize);
}

nextPage  () {
  this.currentPage = this.currentPage + 1;

}

pageSizes  () {
  this.currentPage = 1;
  this.recordCount = 0;
  this.totalPages = 0;

}
SearchAllEnquiry () {
  
     this.spinnerService.show();
    this.SearchModel.CurrentIndex = this.currentPage;
    this.SearchModel.PageSize = this.pageSize;
   
    this.SearchModel.FromDate =this.SearchModel.FromDate!=null && this.SearchModel.FromDate!=''?moment(this.SearchModel.FromDate).format('DD-MMM-YYYY'):'';
    this.SearchModel.ToDate =this.SearchModel.ToDate!=null && this.SearchModel.ToDate!=''?moment(this.SearchModel.ToDate).format('DD-MMM-YYYY'):'';
   
   this. enquiryService.SearchAllEnquiry(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
        this.EnquiryList = data.EnquiryList;
        this.recordCount = 0;
        if (this.EnquiryList != null && this.EnquiryList.length > 0) {
            this.recordCount = this.EnquiryList[0].RecordCount;
        }
         
        this.numberOfPages();
         this.spinnerService.hide();
    });
}
Enquiry={
  EnquiryNo:"",
}

ClearEnquiryNo () {
    this.Enquiry={
      EnquiryNo:"",
    }
}

PrintEquiry () {
    var url = "printenquirydetails?EnquiryNo=" + this.Enquiry.EnquiryNo;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
}


Clear () {
    this.EnquiryModel.EnquiryTypeID = 0;
    this.EnquiryModel.EnquirySourceID = 0;
    this.EnquiryModel.VisitorID = 0;
    this.EnquiryModel.FirstName = '';
    this.EnquiryModel.MiddleName = '';
    this.EnquiryModel.LastName = '';
    this.EnquiryModel.Mobile = '';
    this.EnquiryModel.Address = '';
    this.EnquiryModel.Email = '';
    this.EnquiryModel.Description = '';
    this.EnquiryModel.IsMeeting = false;
    this.EnquiryModel.MeetingDate = moment(new Date()).format('DD-MMM-YYYY');
    this.EnquiryModel.MeetingTime = moment(new Date()).format('DD-MMM-YYYY HH:mm');
    this.EnquiryModel.Agenda = '';
    this.EnquiryModel.StaffID = 0;
    this.EnquiryModel.IsProspectus = false;
    this.EnquiryModel.Amount = 0;
    this.EnquiryModel.PaymentMode = '';
    this.EnquiryModel.ChequeDate = '';
    this.EnquiryModel.ChequeNo = '';
    this.EnquiryModel.BankID = 0;
    this.EnquiryModel.PhotoPath = null;
    this.Submitted = false;
}
Submitted = false;
AllEnquiryTypeList:any;
GetAllEnquiryType (PersonTypeID) {
     this.spinnerService.show();
    var model = {
        'ItemId': PersonTypeID,
    }
    this.lookupService.GetLookupsList('EnquiryType', JSON.stringify(model)).subscribe((data: any) => {
        this.AllEnquiryTypeList = data.LookupItems;
         this.spinnerService.hide();
    });

}
EnquiryTypeList:any;
GetEnquiryType (IsActive) {
 
     this.spinnerService.show();
    var model = {
        'ItemId': IsActive == false ? 1 : 2,
    }
    this.lookupService.GetLookupsList('EnquiryType', JSON.stringify(model)).subscribe((data: any) => {
        this.EnquiryTypeList = data.LookupItems;
        this.EnquiryModel.EnquiryTypeID = 0;
         this.spinnerService.hide();
    });
}






AllEnquirySourceList:any;
GetAllEnquirySource () {
     this.spinnerService.show();
    this.lookupService.GetLookupsList('EnquirySource', '').subscribe((data: any) => {
        this.AllEnquirySourceList = data.LookupItems;
         this.spinnerService.hide();
    });
}

PersonTypeList:any;
GetPersonType () {
    this.lookupService.GetLookupsList('EnqPersonType', '').subscribe((data: any) => {
        this.PersonTypeList = data.LookupItems;
    });
};
StaffList:any;EnqIsExist:any;
GetAllStaff () {
    this.lookupService.GetLookupsList('StaffName', '').subscribe((data: any) => {
        this.StaffList = data.LookupItems;
    });
}
PaymentModeList:any;
GetPaymentMode () {
    this.lookupService.GetLookupsList('PaymentMode', '').subscribe((data: any) => {
        this.PaymentModeList = data.LookupItems;
    });
};
BankList:any;
GetAllBank () {
    this.lookupService.GetLookupsList('BankName', '').subscribe((data: any) => {
        this.BankList = data.LookupItems;

    });
};
 ValidateEnquiryDropdown() {
    return this.EnquiryModel.EnquiryTypeID == 0 ;
};
 ValidateMeetingDropdown() {
    return this.EnquiryModel.StaffID == 0 ;
};
 ValidateProspectusDropdown() {
    return this.EnquiryModel.PaymentMode == '' || this.EnquiryModel.PaymentMode == ' ';
};
loading = false;

SaveEnquiry (valid, meetingvalid, prospectusvalid) {
    this.Submitted = true;
    this.EnquiryModel.MeetingTime=this.EnquiryModel.MeetingTime!=null && this.EnquiryModel.MeetingTime!=''?moment(new Date(this.EnquiryModel.MeetingTime)).format('HH:mm'):'';
    if (!this.EnquiryModel.IsMeeting && !this.EnquiryModel.IsProspectus) {
        if (valid && !this.ValidateEnquiryDropdown()) {
            this.loading = true;
           this. enquiryService.SaveEnquiry(JSON.stringify(this.EnquiryModel)).subscribe((response: any) => {
                this.Enquiry.EnquiryNo = response.EnquiryNo;
                this.EnqIsExist = response.IsExist;

                setTimeout( ()=> {
                    this.Submitted = false;
                    this.loading = false;
                }, 10);
                if (!this.EnqIsExist) {
                    this.globalHelper.CheckActionStatus(response);
                }
                if (this.EnqIsExist) {
                    if (confirm("Enquiry already exist.Are you sure to Open that Enquiry !")) {
                       this. enquiryService.UpdateEnquiryStatus(JSON.stringify(this.EnquiryModel)).subscribe((data: any) => {
                            this.globalHelper.CheckActionStatus(data);
                        });
                    }
                    return false;
                }
                //this.Clear();
                this.SearchAllEnquiry();
            });
        }
    }
    if (this.EnquiryModel.IsMeeting && !this.EnquiryModel.IsProspectus) {
        if (valid && meetingvalid && !this.ValidateEnquiryDropdown() && !this.ValidateMeetingDropdown()) {
            this.loading = true;
           this. enquiryService.SaveEnquiry(JSON.stringify(this.EnquiryModel)).subscribe((response: any) => {
                this.Enquiry.EnquiryNo = response.EnquiryNo;
                this.EnqIsExist = response.IsExist;
                 setTimeout( ()=> {
                    this.Submitted = false;
                    this.loading = false;
                }, 10);
                if (!this.EnqIsExist) {
                    this.globalHelper.CheckActionStatus(response);
                }
                if (this.EnqIsExist) {
                    if (confirm("Enquiry already exist.Are you sure to Open that Enquiry !")) {
                       this. enquiryService.UpdateEnquiryStatus(JSON.stringify(this.EnquiryModel)).subscribe((data: any) => {
                            this.globalHelper.CheckActionStatus(data);
                        });
                    }
                    return false;
                }
                //this.Clear();
                this.SearchAllEnquiry();
            });
        }
    }
    if (this.EnquiryModel.IsProspectus && !this.EnquiryModel.IsMeeting) {
        if (valid && prospectusvalid && !this.ValidateEnquiryDropdown() && !this.ValidateProspectusDropdown()) {
            this.loading = true;
           this. enquiryService.SaveEnquiry(JSON.stringify(this.EnquiryModel)).subscribe((response: any) => {
                this.Enquiry.EnquiryNo = response.EnquiryNo;
                this.EnqIsExist = response.IsExist;
                 setTimeout( ()=> {
                    this.Submitted = false;
                    this.loading = false;
                }, 10);
                if (!this.EnqIsExist) {
                    this.globalHelper.CheckActionStatus(response);
                }
                if (this.EnqIsExist) {
                    if (confirm("Enquiry already exist.Are you sure to Open that Enquiry !")) {
                       this. enquiryService.UpdateEnquiryStatus(JSON.stringify(this.EnquiryModel)).subscribe((data: any) => {
                            this.globalHelper.CheckActionStatus(data);
                        });
                    }
                    return false;
                }
                //this.Clear();
                this.SearchAllEnquiry();
            });
        }
    }
    if (this.EnquiryModel.IsProspectus && this.EnquiryModel.IsMeeting) {
        if (valid && meetingvalid && prospectusvalid && !this.ValidateEnquiryDropdown() && !this.ValidateProspectusDropdown() && !this.ValidateMeetingDropdown()) {
            this.loading = true;
           this. enquiryService.SaveEnquiry(JSON.stringify(this.EnquiryModel)).subscribe((response: any) => {
                this.Enquiry.EnquiryNo = response.EnquiryNo;
                this.EnqIsExist = response.IsExist;
                 setTimeout( ()=> {
                    this.Submitted = false;
                    this.loading = false;
                }, 10);
                if (!this.EnqIsExist) {
                    this.globalHelper.CheckActionStatus(response);
                }
                if (this.EnqIsExist) {
                    if (confirm("Enquiry already exist.Are you sure to Open that Enquiry !")) {
                       this. enquiryService.UpdateEnquiryStatus(JSON.stringify(this.EnquiryModel)).subscribe((data: any) => {
                            this.globalHelper.CheckActionStatus(data);
                        });
                    }
                    return false;
                }
                //this.Clear();
                this.SearchAllEnquiry();
            });
        }
    }
};



//Meeting Scheduled
MeetingModel = {
    MeetingDate:  moment(new Date()).format('DD-MMM-YYYY'),
    MeetingTime: moment(new Date()).format('HH:mm'),
    Agenda: '',
    StaffID: 0,
    EnquiryID: 0,
    Remarks: '',
    MeetingLogID: 0,
    EnquiryNo:"",
    FirstName:"",
    MiddleName:"",
    LastName:"",
}

MeetingSubmitted = false;
ClearMeeting () {
    this.MeetingModel.MeetingDate = moment(new Date()).format('DD-MMM-YYYY');
    this.MeetingModel.MeetingTime = moment(new Date()).format('HH:mm');
    this.MeetingModel.Agenda = '';
    this.MeetingModel.Remarks = '';
    this.MeetingModel.StaffID = 0;
    this.MeetingModel.EnquiryID = 0;
    this.MeetingSubmitted = false;
}
SelectedRowID=0;
OpenMeetingList=[];
MeetingScheduled (item) {
    this.ClearMeeting();
    this.SelectedRowID = item.EnquiryID;
    this.MeetingModel.EnquiryID = item.EnquiryID;
    this.MeetingModel.EnquiryNo = item.EnquiryNo;
    this.MeetingModel.FirstName = item.FirstName;
    this.MeetingModel.MiddleName = item.MiddleName;
    this.MeetingModel.LastName = item.LastName;
    var itembo = {
        'ItemId': item.EnquiryID
    }

    this.lookupService.GetLookupsList('Meeting', JSON.stringify(itembo)).subscribe((data: any) => {
        this.OpenMeetingList = data.LookupItems;
        if (this.OpenMeetingList != null && this.OpenMeetingList.length == 2) {
            this.MeetingModel.MeetingLogID = this.OpenMeetingList[1].ItemId;
        }
        if (this.OpenMeetingList == null) {
            this.MeetingModel.MeetingLogID = 0;
        }
    });
}

 ValidateMeetingSchedule() {
    return this.MeetingModel.StaffID == 0  || this.MeetingModel.MeetingLogID == 0 || this.MeetingModel.Remarks == '';
}
 ValidateMeetingSchedule1() {
    return this.MeetingModel.StaffID == 0 ;
}
loadingMeeting = false;

SaveMeetingSchedule (valid) {
    if (this.MeetingModel.MeetingLogID > 0) {
        this.MeetingSubmitted = true;
        if (valid && !this.ValidateMeetingSchedule()) {
            this.loadingMeeting = true;
            this.MeetingModel.MeetingTime=this.MeetingModel.MeetingTime!=null && this.MeetingModel.MeetingTime!=''?moment(new Date(this.MeetingModel.MeetingTime)).format('HH:mm'):'';
           this. enquiryService.SaveMeetingSchedule(JSON.stringify(this.MeetingModel)).subscribe((response: any) => {
                 setTimeout( ()=> {
                    this.MeetingSubmitted = false;
                    this.loadingMeeting = false;
                }, 10);
                this.globalHelper.CheckActionStatus(response);
                this.ClearMeeting();
            });
        }
    }
    else {
        this.MeetingSubmitted = true;
        if (valid && !this.ValidateMeetingSchedule1()) {
            this.loadingMeeting = true;
            this.MeetingModel.MeetingTime=this.MeetingModel.MeetingTime!=null && this.MeetingModel.MeetingTime!=''?moment(new Date(this.MeetingModel.MeetingTime)).format('HH:mm'):'';
           this. enquiryService.SaveMeetingSchedule(JSON.stringify(this.MeetingModel)).subscribe((response: any) => {
                 setTimeout( ()=> {
                    this.MeetingSubmitted = false;
                    this.loadingMeeting = false;
                }, 10);
                this.globalHelper.CheckActionStatus(response);
                this.ClearMeeting();
            });
        }
    }
}
MeetingsList = [];
GetMeetingsByEnquiry (item) {
    this.SelectedRowID = item.EnquiryID;
    var model = {
        EnquiryID: item.EnquiryID
    }
   this. enquiryService.GetMeetingsByEnquiry(JSON.stringify(model)).subscribe((data: any) => {
        this.MeetingsList = data.MeetingsList;
    });
}
VistorRegisterModel = {
    Mobile: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Email: '',
    Address: '',
    EnquiryType: '',
    EnquiryID: 0,
    PersonType: '',
    EnquiryStatus: 0,
    Description: '',
    INTime: '',
    VisitorID: 0,
    VisitorLogID: 0,


}
GetVisitorRegistor (item) {
    this.SelectedRowID = item.EnquiryID;
    this.VistorRegisterModel.EnquiryID = item.EnquiryID;
    this.VistorRegisterModel.VisitorID = item.VisitorID;
    this.VistorRegisterModel.VisitorLogID = item.VisitorLogID;
    this.VistorRegisterModel.Mobile = item.Mobile;
    this.VistorRegisterModel.FirstName = item.FirstName;
    this.VistorRegisterModel.MiddleName = item.MiddleName;
    this.VistorRegisterModel.LastName = item.LastName;
    this.VistorRegisterModel.Email = item.Email;
    this.VistorRegisterModel.Address = item.Address;
    this.VistorRegisterModel.EnquiryType = item.EnquiryType;
    this.VistorRegisterModel.PersonType = item.PersonType;
    this.VistorRegisterModel.EnquiryStatus = item.EnquiryStatus;
    this.VistorRegisterModel.Description = item.Description;
    this.VistorRegisterModel.INTime = item.INTime;


}
loadingRegister = false;
SaveVisitorRegistor () {
    this.loadingRegister = true;
   this. enquiryService.VisitorRegistor(JSON.stringify(this.VistorRegisterModel)).subscribe((data: any) => {
        this.loadingRegister = false;
        this.globalHelper.CheckActionStatus(data);
    });
}
//Issue Prospectus
ProspectusModel = {
    Amount: 0,
    PaymentMode: 'CASH',
    ChequeDate: '',
    ChequeNo: '',
    BankID: 0,
    Remarks: '',
    EnquiryID: 0,
}
ClearProspectus () {
    this.ProspectusModel.Amount = 0;
    this.ProspectusModel.PaymentMode = 'CASH';
    this.ProspectusModel.ChequeDate = '';
    this.ProspectusModel.ChequeNo = '';
    this.ProspectusModel.BankID = 0;
}
SetIssueProspectus (item) {
    this.SelectedRowID = item.EnquiryID;
    this.ProspectusModel.EnquiryID = item.EnquiryID;
}
loadingProspectusg = false;
IssueProspectusSubmitted = false;
SaveEnqIssueProspectus (valid) {

    this.IssueProspectusSubmitted = true;
    if (valid && !this.ValidateProspectusDropdown()) {
        this.loadingProspectusg = true;
       this. enquiryService.SaveEnqIssueProspectus(JSON.stringify(this.ProspectusModel)).subscribe((response: any) => {
             setTimeout( ()=> {
                this.IssueProspectusSubmitted = false;
                this.loadingProspectusg = false;
            }, 10);
            this.globalHelper.CheckActionStatus(response);
            this.SearchAllEnquiry();
            this.ClearMeeting();
        });
    }
}

// Add Notes
AppointmentModel = {
    StaffID: 0,
    Agenda: '',
    MeetingDate: moment(new Date()).format('DD-MMM-YYYY'),
    MeetingTime: moment(new Date()).format('HH:mm'),
    EnquiryTypeID: 0,
    EnquiryID: 0,
    EnquiryStatusID: 0,
    MeetingLogID: 0,
    Remarks: '',
    IsMeeting: false,
    IsActive: false,
    CloseDate: moment(new Date()).format('DD-MMM-YYYY'),
    CloseTime: moment(new Date()).format('HH:mm'),
}

ClearAddNote () {
    this.AppointmentModel.EnquiryID = 0;

}

ClearAddNoteEnquiry () {
    this.AppointmentModel.MeetingDate = moment(new Date()).format('DD-MMM-YYYY');
    this.AppointmentModel.MeetingTime = moment(new Date()).format('HH:mm');
    this.AppointmentModel.StaffID = 0;
    this.AppointmentModel.Agenda = '';
    this.Submitted = false;

}

GetCurrentTime(){
    this.AppointmentModel.MeetingTime=moment(new Date()).format('DD-MMM-YYYY HH:mm');
}

SetAddNote (obj) {
    this.AppointmentModel.CloseTime='';
    this.AppointmentModel.MeetingTime='';
    this.SelectedRowID = obj.EnquiryID;
    this.AppointmentModel.EnquiryID = obj.EnquiryID;
    this.AppointmentModel.IsActive = true;
    var itembo = {
        'ItemId': obj.EnquiryID
    }

    this.lookupService.GetLookupsList('Meeting', JSON.stringify(itembo)).subscribe((data: any) => {
        this.OpenMeetingList = data.LookupItems;
        if (this.OpenMeetingList != null && this.OpenMeetingList.length == 2) {
            this.AppointmentModel.MeetingLogID = this.OpenMeetingList[1].ItemId;
        }

    });

}

ClearAddNotMeeting () {
    this.AppointmentModel.IsMeeting = false;
    this.AppointmentModel.Remarks = ''

}

 ValidityState() {
    return this.AppointmentModel.StaffID == 0  || this.AppointmentModel.MeetingLogID == 0;
}
 ValidityState1() {
    return this.AppointmentModel.StaffID == 0 ;
}

SaveEnquiryAddNote (Addvalid, Meetvalid) {

  this.AppointmentModel.CloseTime=this.AppointmentModel.CloseTime!=null && this.AppointmentModel.CloseTime!=''?moment(new Date(this.AppointmentModel.CloseTime)).format('HH:mm'):'';
  this.AppointmentModel.MeetingTime=this.AppointmentModel.MeetingTime!=null && this.AppointmentModel.MeetingTime!=''?moment(new Date(this.AppointmentModel.MeetingTime)).format('HH:mm'):'';
    this.Submitted = true;
   
    if (this.OpenMeetingList.length == 1) {
        if (this.AppointmentModel.IsMeeting) {
            if (Meetvalid && !this.ValidityState1()) {
                this.Submitted = false;
                this.loadingMeeting = true;
               this. enquiryService.SaveEnquiryAddNote(JSON.stringify(this.AppointmentModel)).subscribe((response: any) => {
                    this.loadingMeeting = false;
                    this.globalHelper.CheckActionStatus(response);
                    if (response.webResponse.Status) {                       
                        this.ClearAddNoteEnquiry();
                        this.SearchAllEnquiry();
                    }

                });
            }

        }
        else if (!this.AppointmentModel.IsMeeting) {
            this.Submitted = false;
            this.loadingMeeting = true;
           this. enquiryService.SaveEnquiryAddNote(JSON.stringify(this.AppointmentModel)).subscribe((response: any) => {
                this.loadingMeeting = false;
                this.globalHelper.CheckActionStatus(response);
                if (response.webResponse.Status) {
                    this.ClearAddNoteEnquiry();
                    this.SearchAllEnquiry();


                }

            });
        }
    }
    else if (this.AppointmentModel.IsMeeting) {
        if (Meetvalid && !this.ValidityState()) {
            this.Submitted = false;
            this.loadingMeeting = true;
           this. enquiryService.SaveEnquiryAddNote(JSON.stringify(this.AppointmentModel)).subscribe((response: any) => {
                this.loadingMeeting = false;
                this.globalHelper.CheckActionStatus(response);
                if (response.webResponse.Status) {
                  
                    this.ClearAddNoteEnquiry();
                    this.SearchAllEnquiry();


                }

            });
        }
    }
    else {
        if (Addvalid) {
        
            this.Submitted = false;
            this.loadingMeeting = true;
           this. enquiryService.SaveEnquiryAddNote(JSON.stringify(this.AppointmentModel)).subscribe((response: any) => {
                this.loadingMeeting = false;
                this.globalHelper.CheckActionStatus(response);
                if (response.webResponse.Status) {
                   
                    this.ClearAddNoteEnquiry();
                    this.ClearAddNotMeeting();
                    this.SearchAllEnquiry();
                }

            });
        }
    }

}
AddNoteModel = {
    EnquiryID: 0,
    EnquiryNo:""
}
isCollapsed = false;
isCollapsed1 = true;
ClareViewAddNote () {
    this.AddNoteModel.EnquiryID = 0;
    this.AddNoteModel.EnquiryNo = '';
}

AddNoteList = [];
MeetingList:any;
RemarksList:any;
GetAddNoteByEnquiry (item) {
  
    this.SelectedRowID = item.EnquiryID;
    this.AddNoteModel.EnquiryID = item.EnquiryID;
    this.AddNoteModel.EnquiryNo = item.EnquiryNo;
   this. enquiryService.GetAddNoteByEnquiry(JSON.stringify(this.AddNoteModel)).subscribe((data: any) => {
        this.MeetingList = data.MeetingList;
        this.RemarksList = data.RemarksList;
    });
}

// Download
DownloadEnquiryList:any;
EnquiryListDownload () {
     this.spinnerService.show();
    this.SearchModel.CurrentIndex = 0;
    this.SearchModel.PageSize = 0;
   this. enquiryService.SearchAllEnquiry(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
        this.DownloadEnquiryList = data.EnquiryList;
        if (this.DownloadEnquiryList != null) {
            this.JSONToCsvConverterList(this.DownloadEnquiryList, 'Enquiry_List', true);
        }

         this.spinnerService.hide();
    });

};

 JSONToCsvConverterList(JSONData, ReportTitle, ShowLabel) {
    var arrayData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
    var CSV = '';
    if (ShowLabel) {
        var row = "";
        row += 'Sr. No.' + ',';
        row += 'Enquiry No' + ',';
        row += 'Name' + ',';
        row += 'Mobile' + ',';
        row += 'Email' + ',';
        row += 'Address' + ',';
        row += 'Person Type' + ',';
        row += 'Enquiry Type' + ',';
        row += 'Enquiry Source' + ',';
        row += 'Description' + ',';
        row += 'Prospectus Issued' + ',';
        row += 'Enquiry Date' + ',';
        row += 'Enquiry Status' + ',';
        row += 'Latest Remarks' + ',';
        row += 'IN Time' + ',';
        row += 'OUT Time' + ',';
        row = row.slice(0, -1);
        CSV += row + '\r\n';
    }
    for (var i = 0; i < arrayData.length; i++) {
        var sno = i + 1;
        var row = "";
        row += '"' + sno + '",';

        if (arrayData[i].EnquiryNo != null) {
            row += '"' + arrayData[i].EnquiryNo + '",';
        }
        else {
            row += '"' + '' + '",';
        }

        if (arrayData[i].FirstName != null) {
            row += '"' + arrayData[i].FirstName + ' ' + arrayData[i].MiddleName + '' + arrayData[i].LastName + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].Mobile != null) {
            row += '"' + arrayData[i].Mobile + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].Email != null) {
            row += '"' + arrayData[i].Email + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].Address != null) {
            row += '"' + arrayData[i].Address + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].PersonType != null) {
            row += '"' + arrayData[i].PersonType + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].EnquiryType != null) {
            row += '"' + arrayData[i].EnquiryType + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].EnquirySource != null) {
            row += '"' + arrayData[i].EnquirySource + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].Description != null) {
            row += '"' + arrayData[i].Description + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].IsProspectus == true) {
            row += '"' + 'Yes' + '",';
        }
        else {
            row += '"' + 'No' + '",';
        }
        if (arrayData[i].CreatedOn != null) {
            row += '"' +  moment(new Date(arrayData[i].CreatedOn)).format('DD-MMM-YYYY')+ '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].EnquiryStatus != null) {
            row += '"' + arrayData[i].EnquiryStatus + '",';
        }
        else {
            row += '"' + '' + '",';
        }

        if (arrayData[i].LatestNote != null) {
            row += '"' + arrayData[i].LatestNote + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].INTime != null) {
            row += '"' + moment(new Date(arrayData[i].INTime)).format('HH:mm')  + '",';
        }
        else {
            row += '"' + '' + '",';
        }
        if (arrayData[i].OUTTime != null) {
            row += '"' + moment(new Date()).format('HH:mm') + '",';
        }
        else {
            row += '"' + '' + '",';
        }


        row.slice(0, row.length - 1);
        CSV += row + '\r\n';
    }
    if (CSV == '') {
        alert('Invalid Data');
        return;
    }
    var FileName = ReportTitle + '_' + moment(new Date()).format('DD-MMM-YYYY');
    var csvData = new Blob([CSV], { type: 'text/csv;charset=utf-8;' });
    var csvURL = window.URL.createObjectURL(csvData);
    var tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', FileName + '.csv');
    tempLink.click();
}
CurrentTime:any;
  ngOnInit() {
    this.CurrentTime = moment(new Date()).format('HH:mm');
    this.GetPersonType();
    this.GetAllStaff();
    this.GetPaymentMode();
    this.GetAllBank();
    this.GetAllEnquirySource();
    this.GetVisitor();
    
    this.GetEnquiryType(false);
  }

}
